import React from "react";
import { useParams, Navigate } from "react-router-dom";
import SocialFeed from "../../components/SocialFeed";
import Breadcrumb from "../../components/Breadcrumb";
import CTA from "../../components/CTA";

import bgImg from "../../assets/img/cta/cta-bg-2.png";

const ProjectDetailsMain = () => {
  const { projectId } = useParams();

  // Get project data from window (set in ProjectOneMain)
  const projectsData = window.projectsData || [];
  const project = projectsData.find((p) => p.id === projectId);

  // If project not found, redirect to projects page
  if (!project) {
    return <Navigate to="/projects" replace />;
  }

  return (
    <main>
      <Breadcrumb pageTitle={`${project.title} - Project Details`} />

      <div className="project-details__area project-details__plr mt-100 mb-80">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="project-details__item">
                <div
                  className="project-details__img wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".3s"
                  style={
                    project.platform === "Mobile"
                      ? { textAlign: "center" }
                      : {}
                  }
                >
                  <img
                    src={project.mainImage}
                    alt={`${project.title} Dashboard`}
                    style={
                      project.platform === "Mobile"
                        ? {
                            borderRadius: "12px",
                            maxWidth: "220px",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                          }
                        : {}
                    }
                  />
                </div>
                {project.disclaimer && (
                  <div
                    className="project-details__disclaimer wow animate__fadeInUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".4s"
                    style={{
                      backgroundColor: "#fff3cd",
                      border: "2px solid #ffc107",
                      borderRadius: "8px",
                      padding: "20px 25px",
                      marginBottom: "30px",
                      marginTop: "30px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "flex-start", gap: "15px" }}>
                      <i
                        className="fas fa-exclamation-triangle"
                        style={{ color: "#856404", fontSize: "24px", marginTop: "2px" }}
                      ></i>
                      <p
                        style={{
                          margin: 0,
                          color: "#856404",
                          fontSize: "15px",
                          lineHeight: "1.6",
                          fontWeight: "500",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: project.disclaimer
                            .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>"),
                        }}
                      />
                    </div>
                  </div>
                )}
                <div className="project-details__border">
                  <div className="row align-items-center">
                    <div
                      className="col-xl-6 col-lg-7 wow animate__fadeInUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".5s"
                    >
                      <div className="project-details__left">
                        <h4>Project Overview:</h4>
                        <p>
                          <strong>Challenge:</strong>{" "}
                          {project.overview.challenge}
                        </p>
                        <p>
                          <strong>Solution:</strong>{" "}
                          <span
                            dangerouslySetInnerHTML={{
                              __html: project.overview.solution.replace(
                                /\*\*(.*?)\*\*/g,
                                "<strong>$1</strong>"
                              ),
                            }}
                          />
                        </p>
                      </div>
                    </div>
                    <div
                      className="col-xl-6 col-lg-5 wow animate__fadeInUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".7s"
                    >
                      <div className="project-details__right">
                        <ul>
                          <li>
                            <i className="far fa-check-circle"></i>
                            <span>Client:</span>
                            {project.client}
                          </li>
                          <li>
                            <i className="far fa-check-circle"></i>
                            <span>Timeline:</span>
                            {project.timeline}
                          </li>
                          <li>
                            <i className="far fa-check-circle"></i>
                            <span>Technology:</span>
                            {project.technology}
                          </li>
                          <li>
                            <i className="far fa-check-circle"></i>
                            <span>Type:</span>
                            {project.type} ({project.platform})
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="social__area social__mlr pb-70">
        <div className="container-fluid">
          <SocialFeed />
        </div>
      </div>

      <div className="project-details__area pb-100">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="project-details__item">
                {project.platform === "Mobile" ? (
                  // Mobile app layout - vertical phone screenshots
                  <>
                    {/* First row of mobile screenshots */}
                    <div
                      className="row pb-50 justify-content-center"
                      style={{ gap: "20px 0" }}
                    >
                      {project.images.slice(1, 5).map((img, index) => (
                        <div
                          key={index}
                          className="col-6 col-md-4 col-lg-3"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <div
                            className="wow animate__fadeInUp"
                            data-wow-duration=".9s"
                            data-wow-delay={`${0.3 + index * 0.1}s`}
                            style={{ maxWidth: "200px" }}
                          >
                            <img
                              src={img}
                              alt={`${project.title} Screenshot ${index + 2}`}
                              style={{
                                borderRadius: "12px",
                                width: "100%",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>

                    <div
                      className="project-details__text wow animate__fadeInUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".7s"
                    >
                      <p>
                        <strong>The Problem:</strong> {project.problemStatement}
                      </p>
                      <p>
                        <strong>The Development Process:</strong>{" "}
                        <span
                          dangerouslySetInnerHTML={{
                            __html: project.developmentProcess.replace(
                              /\*\*(.*?)\*\*/g,
                              "<strong>$1</strong>"
                            ),
                          }}
                        />
                      </p>
                      <p className="pb-40">
                        <strong>User Training & Support:</strong> After
                        development, I provided comprehensive training to the
                        staff, ensuring they could confidently use all system
                        features. I also established an ongoing support system
                        for any questions or additional feature requests that
                        might arise as their business grows.
                      </p>
                    </div>

                    <div className="row align-items-center">
                      <div
                        className="col-xl-12 col-lg-12 wow animate__fadeInLeft"
                        data-wow-duration=".9s"
                        data-wow-delay=".8s"
                      >
                        <div className="project-details__solution">
                          <h4>Key Results Achieved:</h4>
                          <p>
                            The implementation of this system transformed the{" "}
                            {project.client.toLowerCase()}'s operations,
                            delivering measurable improvements in efficiency and
                            service quality.
                          </p>
                          <ul>
                            {project.results.map((result, index) => (
                              <li key={index}>
                                <i className="far fa-check-square"></i>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: result.replace(
                                      /\*\*(.*?)\*\*/g,
                                      "<strong>$1</strong>"
                                    ),
                                  }}
                                />
                              </li>
                            ))}
                          </ul>
                          <p>
                            <strong>ROI:</strong> {project.roi}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Remaining mobile screenshots */}
                    {project.images.length > 5 && (
                      <div className="row pt-50 justify-content-center" style={{ gap: "20px 0" }}>
                        <div className="col-12 text-center pb-30">
                          <h4>More Screenshots</h4>
                        </div>
                        {project.images.slice(5).map((img, index) => (
                          <div
                            key={index}
                            className="col-6 col-md-4 col-lg-3"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            <div
                              className="wow animate__fadeInUp"
                              data-wow-duration=".9s"
                              data-wow-delay={`${0.3 + index * 0.1}s`}
                              style={{ maxWidth: "200px" }}
                            >
                              <img
                                src={img}
                                alt={`${project.title} Screenshot ${index + 6}`}
                                style={{
                                  borderRadius: "12px",
                                  width: "100%",
                                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  // Web app layout - existing layout
                  <>
                    <div className="row pb-50">
                      {project.images[1] && (
                        <div className="col-xl-6 col-lg-6">
                          <div
                            className="project-details__img wow animate__fadeInUp"
                            data-wow-duration=".9s"
                            data-wow-delay=".3s"
                          >
                            <img
                              src={project.images[1]}
                              alt={`${project.title} Interface 1`}
                            />
                          </div>
                        </div>
                      )}
                      {project.images[3] && (
                        <div className="col-xl-6 col-lg-6">
                          <div
                            className="project-details__img wow animate__fadeInUp"
                            data-wow-duration=".9s"
                            data-wow-delay=".5s"
                          >
                            <img
                              src={project.images[3]}
                              alt={`${project.title} Interface 2`}
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    <div
                      className="project-details__text wow animate__fadeInUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".7s"
                    >
                      <p>
                        <strong>The Problem:</strong> {project.problemStatement}
                      </p>
                      <p>
                        <strong>The Development Process:</strong>{" "}
                        <span
                          dangerouslySetInnerHTML={{
                            __html: project.developmentProcess.replace(
                              /\*\*(.*?)\*\*/g,
                              "<strong>$1</strong>"
                            ),
                          }}
                        />
                      </p>
                      <p className="pb-40">
                        <strong>User Training & Support:</strong> After
                        development, I provided comprehensive training to the
                        staff, ensuring they could confidently use all system
                        features. I also established an ongoing support system
                        for any questions or additional feature requests that
                        might arise as their business grows.
                      </p>
                    </div>
                    <div className="row align-items-center">
                      <div
                        className="col-xl-5 col-lg-6 wow animate__fadeInLeft"
                        data-wow-duration=".9s"
                        data-wow-delay=".8s"
                      >
                        <div className="project-details__solution">
                          <h4>Key Results Achieved:</h4>
                          <p>
                            The implementation of this system transformed the{" "}
                            {project.client.toLowerCase()}'s operations,
                            delivering measurable improvements in efficiency and
                            service quality.
                          </p>
                          <ul>
                            {project.results.map((result, index) => (
                              <li key={index}>
                                <i className="far fa-check-square"></i>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: result.replace(
                                      /\*\*(.*?)\*\*/g,
                                      "<strong>$1</strong>"
                                    ),
                                  }}
                                />
                              </li>
                            ))}
                          </ul>
                          <p>
                            <strong>ROI:</strong> {project.roi}
                          </p>
                        </div>
                      </div>
                      <div
                        className="col-xl-7 col-lg-6 wow animate__fadeInRight"
                        data-wow-duration=".9s"
                        data-wow-delay=".9s"
                      >
                        {project.images[2] && (
                          <div className="project-details__img text-start text-lg-end">
                            <img
                              src={project.images[2]}
                              alt={`${project.title} Analytics`}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {project.images[4] && (
                      <div className="row pt-50">
                        <div className="col-xl-12">
                          <div
                            className="project-details__img wow animate__fadeInUp"
                            data-wow-duration=".9s"
                            data-wow-delay=".3s"
                          >
                            <img
                              src={project.images[4]}
                              alt={`${project.title} Additional Features`}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <CTA
        ctaBG={bgImg}
        Title="Need a Similar Business Solution?"
        Description="I specialize in creating custom management systems that solve real operational challenges. Let's discuss how I can help transform your business processes with modern technology."
        btnText="Discuss My Project"
        btnURL="contact"
      />
    </main>
  );
};

export default ProjectDetailsMain;
